import { Checkbox, FormControlLabel } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { StyledCheckbox } from "../../../../../components/Checkboxes/checkboxes";
import { theme } from "../../../../../helpers/theme";
import { url } from "../../../../../utils/url";

interface PrivacyPolicyProps {
  privacyPolitycyAccept: boolean;
  setPrivacyPolitycyAccept: (accept: boolean) => void;
}

const PrivacyPolicy = ({
  privacyPolitycyAccept,
  setPrivacyPolitycyAccept,
}: PrivacyPolicyProps) => {
  const navigate = useNavigate();

  return (
    <PrivacyPolicyWrapper>
      <StyledCheckbox
        onChange={() => setPrivacyPolitycyAccept(!privacyPolitycyAccept)}
        name="privacyPolicy"
        checked={privacyPolitycyAccept}
        sx={{ padding: "8px 6px 8px 0px" }}
      />
      <PrivacyPolicyLabel>
        Przeczytałem i akceptuję warunki{` `}
        <PrivacyPolicyLink onClick={() => navigate(url.regulations)}>
          Regulaminu{` `}
        </PrivacyPolicyLink>
        i{` `}
        <PrivacyPolicyLink onClick={() => navigate(url.privacyPolicy)}>
          Polityki Prywatności
        </PrivacyPolicyLink>
      </PrivacyPolicyLabel>
    </PrivacyPolicyWrapper>
  );
};

export default PrivacyPolicy;

const PrivacyPolicyWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;
const PrivacyPolicyLabel = styled.label`
  font-family: ${theme.fonts.interMedium};
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: black;
`;
const PrivacyPolicyLink = styled.label`
  text-decoration: underline;
  cursor: pointer;
`;
